export default __webpack_public_path__ + "static/media/hylyAI.6c326dc0.svg";